export default __webpack_public_path__ + "static/media/72.a5631207.jpg";